import { IRevenueSpendByAccountRevenueDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountRevenueDetailsTableLang: IRevenueSpendByAccountRevenueDetailsTableLang = {
	revenue_spend_by_account_revenue_details_table: {
		column_date_click: 'Date Click_ru',
		column_date_sale: 'Date Sale_ru',
		column_revenue: 'Revenue_ru',
		column_offer: 'Offer_ru',
		column_sub_id: 'Sub ID_ru',
		column_sub_id_2: 'Sub ID 2_ru',
		column_campaign_group: 'Campaign Group_ru',
		column_kt_group: 'KT Group_ru',
		column_original_status: 'Original Status_ru',
	}
}